import NaptimeItemClient from 'pages/open-course/common/naptimeItemClient';
import config from 'pages/open-course/supplement/constants/config';

export default ({ itemId, courseId, courseSlug }: $TSFixMe) => {
  const naptimeClient = new NaptimeItemClient({ itemId, courseId, courseSlug });

  const args = {
    includes: ['asset'],
    fields: ['openCourseAssets.v1(typeName)', 'openCourseAssets.v1(definition)', 'minimumDurationToComplete'],
  };

  return naptimeClient.getWithCourseItemId(config.supplementsApi, args).then((response: $TSFixMe) => {
    const minimumDurationToComplete = response.elements[0].minimumDurationToComplete;
    const cml = response.linked['openCourseAssets.v1'][0];
    return { cml, minimumDurationToComplete };
  });
};
